/**
 * The debounce function delays the processing of the given function until
 * it is not called for a predetermined amount of time.
 *
 * @param fn the function to delay
 * @param ms amount of time in milliseconds to wait for calls
 * @returns a function wrapper which debounces the `fn` function
 */
export const debounce = <T extends (...args: any[]) => void>(fn: T, ms: number) => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    return (...args: Parameters<T>) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn(...args), ms);
    };
}
